import { useEffect, useState, useRef } from "react";
import "../../../styles/hero-v2.css";

const HeroSection = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const heroRef = useRef(null);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <section className="hero-v2" ref={heroRef}>
            {/* Subtle Background */}
            <div className="hero-v2-bg">
                <div className="hero-v2-noise" />
            </div>

            {/* Main Content */}
            <div className="hero-v2-content">
                <div className="container-default w-container">
                    {/* Top Tag */}
                    <div className={`hero-v2-tag ${isLoaded ? 'visible' : ''}`}>
                        <span className="hero-v2-tag-dot" />
                        <span>Software Development Agency</span>
                    </div>

                    {/* Main Title */}
                    <h1 className={`hero-v2-title ${isLoaded ? 'visible' : ''}`}>
                        <span className="hero-v2-title-line">
                            <span className="hero-v2-title-word">We</span>
                            <span className="hero-v2-title-word">Build</span>
                        </span>
                        <span className="hero-v2-title-line">
                            <span className="hero-v2-title-word hero-v2-title-accent">Digital</span>
                            <span className="hero-v2-title-word">Products</span>
                        </span>
                        <span className="hero-v2-title-line">
                            <span className="hero-v2-title-word">That</span>
                            <span className="hero-v2-title-word hero-v2-title-outline">Matter</span>
                        </span>
                    </h1>

                    {/* Description */}
                    <p className={`hero-v2-description ${isLoaded ? 'visible' : ''}`}>
                        Transforming ambitious ideas into powerful software solutions. 
                        We partner with visionary companies to create experiences that 
                        captivate users and drive growth.
                    </p>

                    {/* CTA Buttons */}
                    <div className={`hero-v2-actions ${isLoaded ? 'visible' : ''}`}>
                        <a href="/contact" className="hero-v2-btn primary">
                            <span>Start a Project</span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                        </a>
                        <a href="/projects" className="hero-v2-btn secondary">
                            <span>View Our Work</span>
                        </a>
                    </div>
                </div>
            </div>

            {/* Scroll Indicator */}
            <div className={`hero-v2-scroll ${isLoaded ? 'visible' : ''}`}>
                <div className="hero-v2-scroll-line" />
                <span>Scroll</span>
            </div>
        </section>
    );
};

export default HeroSection;

/* ========================================
   ORIGINAL HERO SECTION (COMMENTED OUT)
   ========================================

import ImageMain
    from "../../../assets/64232af5f560211abb908309_a-creative-brand-studio-from-san-francisco-darkstudio-x-webflow-template.png";
import useScrollAnimation from "../../../hooks/useScrollAnimation";
import "../../../styles/scroll-animations.css";

const HeroSectionOriginal = () => {
    const [textRef, textVisible] = useScrollAnimation({ threshold: 0.2 });
    const [imageRef, imageVisible] = useScrollAnimation({ threshold: 0.1 });

    return (
        <div className="section home-hero-section">
            <div className="container-default w-container">
                <div className="w-layout-grid grid-1-column gap-row-64px">
                    <div 
                        ref={textRef}
                        data-w-id="062d0fbe-9e9d-02be-f036-dfd0797421e5"
                        className={`inner-container _1070px scroll-animate scroll-fade-up ${textVisible ? 'visible' : ''}`}
                        style={{ zIndex: 2 }}
                    >
                        <div className="big-font-title" style={{textAlign: 'left'}}>YNVSN</div>
                        <h1 className="display-1" style={{textAlign: 'left'}}>Industry Leading Tech Solutions<br/>In
                            South Carolina</h1>
                        <div className="inner-container _510px _100-tablet">
                            <p className="mg-bottom-40px">
                                Empowering businesses worldwide with cutting-edge software and digital innovation.
                            </p>
                        </div>
                        <div className="buttons-row"><a href="/contact"
                                                        className="btn-secondary button-row w-button">Contact
                            us</a><a href="/projects"
                                     className="btn-secondary white w-button">Our projects</a></div>
                    </div>
                    <div 
                        ref={imageRef}
                        id="w-node-_22495262-4428-237f-1b1f-af418b714aec-1d76e104"
                        data-w-id="22495262-4428-237f-1b1f-af418b714aec"
                        className={`image-wrapper section-hero---home scroll-animate scroll-scale-up scroll-delay-2 ${imageVisible ? 'visible' : ''}`}
                    >
                        <img
                            src={ImageMain}
                            alt="Younivision"
                            className="image"/>
                        <div className="bg-overlay home-hero-image"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

*/
